const SvgOperatingSystems1 = (props) => (
  <>
    <path fill={props.p10} stroke={props.p30} strokeMiterlimit={10} d="M111.95 143.87h-64v-64h64z" />
    <path
      fill="none"
      stroke={props.p30}
      strokeMiterlimit={10}
      d="M143.95 111.87h-64v-64h64zM79.95 175.87h-64v-64h64zM175.99 15.82-.2 192.18M176.2 31.81V15.82h-15.99"
    />
    <circle cx={79.95} cy={111.87} r={4} fill={props.p30} />
    <circle cx={111.95} cy={79.87} r={4} fill={props.p30} />
    <circle cx={47.95} cy={143.87} r={4} fill={props.p30} />
  </>
);

export default SvgOperatingSystems1;
